// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DomEl$GameDataCore from "../DomEl.res.mjs";

var defaultWidthRatio = 1.0 / 3.0;

function isNarrowViewport(viewportWidth) {
  return viewportWidth < 1480;
}

function getDefaultWidth(viewportWidth) {
  return viewportWidth * defaultWidthRatio + 0.5 | 0;
}

function shouldReserveShellSpace(hasAlignmentEvidenceClass, hasFixedClass, viewportWidth) {
  if (!hasAlignmentEvidenceClass && hasFixedClass) {
    return viewportWidth >= 1480;
  } else {
    return false;
  }
}

function isNearResizeEdge(clientX, rectLeft, resizeZoneOpt) {
  var resizeZone = resizeZoneOpt !== undefined ? resizeZoneOpt : 12;
  if (clientX <= rectLeft + resizeZone) {
    return clientX >= rectLeft;
  } else {
    return false;
  }
}

function clampDragWidth(startWidth, startX, clientX, viewportWidth) {
  var delta = startX - clientX;
  var raw = startWidth + delta;
  var maxWidth = viewportWidth * 0.6;
  return Math.min(maxWidth, Math.max(48, raw));
}

function finalizeDragWidth(finalWidth) {
  if (finalWidth <= 96) {
    return "Close";
  } else if (finalWidth < 280) {
    return "SnapToMin";
  } else {
    return {
            TAG: "SaveWidth",
            _0: finalWidth
          };
  }
}

var savedTrayWidth = {
  contents: undefined
};

var rhsTrayVar = "--rhs-tray-w";

function setRhsTrayReserve(px) {
  var rootStyle = document.documentElement.style;
  if (px <= 0.0) {
    rootStyle.removeProperty(rhsTrayVar);
  } else {
    rootStyle.setProperty(rhsTrayVar, String(px) + "px");
  }
}

function clearRhsTrayReserve() {
  setRhsTrayReserve(0);
}

function setTrayLayout(el, w) {
  if (window.innerWidth < 1480) {
    el.style.width = "";
    el.style.maxWidth = "";
    return setRhsTrayReserve(0);
  } else {
    el.style.width = String(w) + "px";
    if (shouldReserveShellSpace(DomEl$GameDataCore.hasClass(el, "game-hub-alignment-evidence-tray") || DomEl$GameDataCore.hasClass(el, "tray-layout-overlay"), DomEl$GameDataCore.hasClass(el, "fixed"), window.innerWidth)) {
      return setRhsTrayReserve(w);
    } else {
      return setRhsTrayReserve(0);
    }
  }
}

function applyTrayWidth(el) {
  if (window.innerWidth < 1480) {
    return setTrayLayout(el, 0);
  }
  var value = savedTrayWidth.contents;
  var w = value !== undefined ? value : getDefaultWidth(window.innerWidth);
  setTrayLayout(el, w);
}

function mounted() {
  var self = this ;
  var el = self.el;
  var isResizing = {
    contents: false
  };
  var startX = {
    contents: 0
  };
  var startWidth = {
    contents: 0
  };
  applyTrayWidth(el);
  var onResize = function (_event) {
    applyTrayWidth(el);
  };
  window.addEventListener("resize", onResize, {
        passive: true
      });
  var elMouseMove = function ($$event) {
    if (isResizing.contents) {
      return ;
    }
    var rect = el.getBoundingClientRect();
    var near = isNearResizeEdge($$event.clientX, rect.left, undefined);
    if (near) {
      el.style.cursor = "ew-resize";
    } else {
      el.style.cursor = "";
    }
  };
  var elMouseDown = function ($$event) {
    var rect = el.getBoundingClientRect();
    if (!isNearResizeEdge($$event.clientX, rect.left, undefined)) {
      return ;
    }
    isResizing.contents = true;
    startX.contents = $$event.clientX;
    startWidth.contents = el.offsetWidth;
    var bodyStyle = document.body.style;
    bodyStyle.cursor = "ew-resize";
    bodyStyle.userSelect = "none";
    $$event.preventDefault();
  };
  var elMouseLeave = function (_event) {
    if (!isResizing.contents) {
      el.style.cursor = "";
      return ;
    }
    
  };
  var offElMove = DomEl$GameDataCore.on(el, "mousemove", elMouseMove);
  var offElDown = DomEl$GameDataCore.on(el, "mousedown", elMouseDown);
  var offElLeave = DomEl$GameDataCore.on(el, "mouseleave", elMouseLeave);
  var docMouseMove = function ($$event) {
    if (!isResizing.contents) {
      return ;
    }
    var clamped = clampDragWidth(startWidth.contents, startX.contents, $$event.clientX, window.innerWidth);
    setTrayLayout(el, clamped);
  };
  var docMouseUp = function (_event) {
    if (!isResizing.contents) {
      return ;
    }
    isResizing.contents = false;
    var bodyStyle = document.body.style;
    bodyStyle.cursor = "";
    bodyStyle.userSelect = "";
    el.style.cursor = "";
    var finalW = el.offsetWidth;
    var w = finalizeDragWidth(finalW);
    if (typeof w === "object") {
      savedTrayWidth.contents = w._0;
      return ;
    }
    if (w === "Close") {
      savedTrayWidth.contents = undefined;
      var closeBtn = el.querySelector("[data-tray-close]");
      if (!(closeBtn == null)) {
        closeBtn.click();
        return ;
      } else {
        return ;
      }
    }
    setTrayLayout(el, 280);
    savedTrayWidth.contents = 280;
  };
  document.addEventListener("mousemove", docMouseMove);
  document.addEventListener("mouseup", docMouseUp);
  self._trayTeardown = (function () {
      window.removeEventListener("resize", onResize);
      offElMove();
      offElDown();
      offElLeave();
      document.removeEventListener("mousemove", docMouseMove);
      document.removeEventListener("mouseup", docMouseUp);
      setRhsTrayReserve(0);
    });
}

function updated() {
  var self = this ;
  applyTrayWidth(self.el);
}

function destroyed() {
  var self = this ;
  self._trayTeardown();
}

var resizableTray = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var appShellMdMinPx = 1480;

var minWidth = 280;

var maxWidthRatio = 0.6;

var resizeDragFloorPx = 48;

var resizeCloseBelowPx = 96;

var resizeZonePx = 12;

export {
  appShellMdMinPx ,
  defaultWidthRatio ,
  minWidth ,
  maxWidthRatio ,
  resizeDragFloorPx ,
  resizeCloseBelowPx ,
  resizeZonePx ,
  isNarrowViewport ,
  getDefaultWidth ,
  shouldReserveShellSpace ,
  isNearResizeEdge ,
  clampDragWidth ,
  finalizeDragWidth ,
  savedTrayWidth ,
  rhsTrayVar ,
  setRhsTrayReserve ,
  clearRhsTrayReserve ,
  setTrayLayout ,
  applyTrayWidth ,
  mounted ,
  updated ,
  destroyed ,
  resizableTray ,
}
/* mounted Not a pure module */
